import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import checkRoute from '../checkRoute';

const Item = ({
  className,
  FirstIcon,
  SecondIcon,
  color,
  text,
  path,
  actualPath,
}) => (
  <Link to={path} className={className}>
    {path === actualPath ? (
      <>
        <FirstIcon fontSize="large" style={{ color }} />
      </>
    ) : (
      <>
        <SecondIcon fontSize="large" style={{ color }} />
      </>
    )}
    {window.innerWidth >= 992 && checkRoute(path, actualPath, text, color)}
  </Link>
);

Item.propTypes = {
  className: PropTypes.string.isRequired,
  FirstIcon: PropTypes.elementType.isRequired,
  SecondIcon: PropTypes.elementType.isRequired,
  color: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  actualPath: PropTypes.string.isRequired,
};

export default styled(Item)`
  display: flex;
  align-items: center;
`;
